export default {
  path: '',
  component: () => import(`@/page/distributor/component/basic-layout/1.0.4/index.vue`),
  children: [
    {
      path: '/distributor/tour/front/search',
      name: 'distributor-tour-front-search',
      meta: {
        skip_check_token: true,
        footer_margin_none: true,
      },
      component: () => import('./1.0.1/index.vue'),
    },
  ]
};
